import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';
import { UserInteractionInstrumentation } from '@opentelemetry/instrumentation-user-interaction';
import { LongTaskInstrumentation } from '@opentelemetry/instrumentation-long-task';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { CompositePropagator, W3CTraceContextPropagator } from '@opentelemetry/core';

const disableTelemetry = process.env.REACT_APP_DISABLE_TELEMETRY === 'true' || process.env.REACT_APP_DISABLE_TELEMETRY === '1';

if (!disableTelemetry) {
    const serviceName = process.env.REACT_APP_OTEL_SERVICE_NAME || 'coverflow-fe';
    const beUrl = process.env.REACT_APP_BE_URL || 'http://localhost:8080';

    // We proxy traces through our own backend to avoid CORS issues and keep credentials secure
    const collectorUrl = `${beUrl}/v1/traces`;

    const resource = resourceFromAttributes({
        'service.name': serviceName,
        'deployment.environment': process.env.NODE_ENV || 'development',
    });

    // No need for headers here anymore, the backend proxy will inject them
    const exporter = new OTLPTraceExporter({
        url: collectorUrl,
    });

    const provider = new WebTracerProvider({
        resource,
        spanProcessors: [new BatchSpanProcessor(exporter)],
    });

    provider.register({
        contextManager: new ZoneContextManager(),
        propagator: new CompositePropagator({
            propagators: [new W3CTraceContextPropagator()],
        }),
    });

    const beOrigin = new URL(beUrl).origin;

    registerInstrumentations({
        instrumentations: [
            new DocumentLoadInstrumentation(),
            new UserInteractionInstrumentation(),
            new LongTaskInstrumentation(),
            new FetchInstrumentation({
                propagateTraceHeaderCorsUrls: [
                    new RegExp(`${beOrigin.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}.*`),
                ],
            }),
            new XMLHttpRequestInstrumentation({
                propagateTraceHeaderCorsUrls: [
                    new RegExp(`${beOrigin.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}.*`),
                ],
            }),
        ],
    });

    console.log(`OpenTelemetry initialized for ${serviceName} proxying through ${collectorUrl}`);
} else {
    console.log('Telemetry is disabled via REACT_APP_DISABLE_TELEMETRY');
}
